module.exports = __webpack_public_path__ + "static/media/Acheive12.dd020346.jpeg";